export default "__VITE_ASSET__CX$x_lG3__"